import { render, staticRenderFns } from "./ReceiptModal-Simple.vue?vue&type=template&id=e671924a&scoped=true&"
import script from "./ReceiptModal-Simple.vue?vue&type=script&lang=js&"
export * from "./ReceiptModal-Simple.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptModal-Simple.vue?vue&type=style&index=0&id=e671924a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e671924a",
  null
  
)

export default component.exports